// extracted by mini-css-extract-plugin
export default {"BoxContador":"contador_BoxContador__59ZQr","Contador":"contador_Contador__kCGGz","Count":"contador_Count__-oAlU"};